import { FieldReviewTable } from '../fieldReviewTable';
import { formatEntityValue } from './entityReviewFields';

export interface EntityReviewTableProps {
  data: Record<string, any>;
}

export const EntityReviewTable = ({ data }: EntityReviewTableProps) => {
  const items = (data?.items ?? []).map(item => ({
    ...item,
    data: formatEntityValue(item.itemName, item.data),
    expectedData: formatEntityValue(item.itemName, item.expectedData),
  }));
  return <FieldReviewTable items={items} />;
};
